import Service from '../../services'
import Swal from "sweetalert2";
// initial state
const state = {

    indexForm: {
        index_code: '',
        name_th: '',
        name_en: '',
        unit_id: null
    },
    indexGroupForm: {
      name_th: '',
      name_en: '',
      group_index: []
    },

    allIndex: [],
    allIndexPaginate: {},
    allIndexGroupPaginate: {}

};


// getters
const getters = {

    indexOption: (state) => {
        let index = [];
        for (let i = 0; i < state.allIndex.length; i++) {
            index.push({
                id: state.allIndex[i].id,
                text: state.allIndex[i].index_code + ' - ' + state.allIndex[i].name_th
            });
        }
        // console.log(index[0]);
        return index;
    }

};


// actions
const actions = {

    // index
    onGetAllIndex({ commit }, data) {
        return Service.index.getAllIndex(data).then((res) => {
            commit('setAllIndex', res);
        });
    },

    onGetAllIndexPaginate({ commit }, data) {
        return Service.index.getAllIndexPaginate(data).then((res) => {
            commit('setAllIndexPaginate', res);
        });
    },

    onGetIndex({ commit }, data) {
        return Service.index.getIndex(data).then((res) => {
            commit('setIndex', res);
        });
    },

    onCreateIndex({ commit }, data) {
        return Service.index.createIndex(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditIndex({ commit }, data) {
        return Service.index.editIndex(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteIndex({ commit }, data) {
        return Service.index.deleteIndex(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    },


    // index group
    onGetAllIndexGroupPaginate({ commit }, data) {
        return Service.index.getAllIndexGroupPaginate(data).then((res) => {
            commit('setAllIndexGroupPaginate', res);
        });
    },

    onGetIndexGroup({ commit }, data) {
        return Service.index.getIndexGroup(data).then((res) => {
            commit('setIndexGroup', res);
        });
    },

    onCreateIndexGroup({ commit }, data) {
        return Service.index.createIndexGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'เพิ่มข้อมูลสำเร็จ',
            })
            // alert('เพิ่มข้อมูลสำเร็จ');
        });
    },

    onEditIndexGroup({ commit }, data) {
        return Service.index.editIndexGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'แก้ไขข้อมูลสำเร็จ',
            })
            // alert('แก้ไขข้อมูลสำเร็จ');
        });
    },

    onDeleteIndexGroup({ commit }, data) {
        return Service.index.deleteIndexGroup(data).then(() => {
            Swal.fire({
                icon: 'success',
                title: 'เรียบร้อย!',
                text: 'ลบข้อมูลสำเร็จ',
            })
            // alert('ลบข้อมูลสำเร็จ');
        });
    }

};


// mutations
const mutations = {

    // index
    setAllIndex(state, data) {
        state.allIndex = data;
    },

    setAllIndexPaginate(state, data) {
        state.allIndexPaginate = data;
    },

    setIndex(state, data) {
        state.indexForm = {
            index_code: data.index_code,
            name_th: data.name_th,
            name_en: data.name_en,
            unit_id: data.unit_id
        };
    },


    // index group
    setAllIndexGroupPaginate(state, data) {
        state.allIndexGroupPaginate = data;
    },

    setIndexGroup(state, data) {
        state.indexGroupForm = {
            name_th: data.name_th,
            name_en: data.name_en,
            group_index: data.group_index
        }
    }

};


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
